//=====================================================================
// Mouse events Object
//=====================================================================
export function tooltipMouseEvents() {
    return {
        "hover": "mouseover",
        "hoverOut": "mouseout",
        "click": "click",
    }
}

export function tooltipPositionClasses() {
    return {
        "above": "cTooltip--top",
        "below": "cTooltip--bottom",
        "left": "cTooltip--left",
        "right": "cTooltip--right"
    }
}



// Popover button (also using window scroll fo position)
export function tooltipTiggerVariables(trigger, scrollPosition) {
    const triggerFromTop = Math.floor(trigger.getBoundingClientRect().top);
    const triggerFromTopPlusScroll = Math.floor(triggerFromTop + scrollPosition);
    const triggerFromLeft = trigger.getBoundingClientRect().left;
    const triggerFromRight = trigger.getBoundingClientRect().right;
    const triggerWidth = trigger.clientWidth / 2;
    const triggerHeight = trigger.clientHeight;

    return {
        triggerFromTop,
        triggerFromLeft,
        triggerFromRight,
        triggerWidth,
        triggerHeight,
        triggerFromTopPlusScroll
    };
}


// Popover content variables
export function tooltipContentVariables(content) {
    const tooltipWidth = Math.floor(content.clientWidth);
    const tooltipWidthHalf = tooltipWidth / 2;
    const tooltipHeight = Math.floor(content.clientHeight);

    return {
        tooltipWidth,
        tooltipWidthHalf,
        tooltipHeight
    };
}

// window variables
export function windowProperties() {
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const windowScrollPosition = Math.floor(window.scrollY);

    return {
        windowHeight,
        windowWidth,
        windowScrollPosition
    };
}